import { defineStore } from 'pinia'

export const useServicesStore = defineStore('services', {
  state: () => ({
    devices: [],
    isLoading: false,
    error: null,
    lastUpdate: null
  }),

  getters: {
    getAllDevices: (state) => state.devices,
    
    getDeviceById: (state) => (deviceId) => {
      return state.devices.find(d => d.device_id === deviceId)
    },

    getServicesByDevice: (state) => (deviceId) => {
      const device = state.devices.find(d => d.device_id === deviceId)
      return device?.services || []
    },

    getServiceStatus: (state) => (deviceId, serviceType) => {
      const device = state.devices.find(d => d.device_id === deviceId)
      if (!device) return null

      const service = device.services?.find(s => s.ServiceType === serviceType)
      return service?.Status || null
    },

    getTotalServices: (state) => {
      return state.devices.reduce((total, device) => {
        return total + (device.services?.length || 0)
      }, 0)
    },

    getActiveServices: (state) => {
      let count = 0
      state.devices.forEach(device => {
        device.services?.forEach(service => {
          if (service.Status === 'Active') {
            count++
          }
        })
      })
      return count
    },

    getPausedServices: (state) => {
      let count = 0
      state.devices.forEach(device => {
        device.services?.forEach(service => {
          if (service.Status === 'Paused') {
            count++
          }
        })
      })
      return count
    }
  },

  actions: {
    setDevices(devices) {
      this.devices = devices
      this.lastUpdate = new Date()
      this.error = null
    },

    setLoading(isLoading) {
      this.isLoading = isLoading
    },

    setError(error) {
      this.error = error
    },

    clearError() {
      this.error = null
    },

    addDevice(device) {
      const existingIndex = this.devices.findIndex(d => d.device_id === device.device_id)
      if (existingIndex !== -1) {
        this.devices[existingIndex] = device
      } else {
        this.devices.push(device)
      }
    },

    removeDevice(deviceId) {
      this.devices = this.devices.filter(d => d.device_id !== deviceId)
    },

    reset() {
      this.devices = []
      this.isLoading = false
      this.error = null
      this.lastUpdate = null
    }
  },

  persist: {
    enabled: true,
    strategies: [
      {
        key: 'services_store',
        storage: localStorage,
        paths: ['devices', 'lastUpdate']
      }
    ]
  }
})
